import { useGetTerritoryQuery } from 'src/api/redux';

/**
 * Hook to fetch a single territory by ID
 * Wraps the RTK Query useGetTerritoryQuery with skip logic for special cases
 *
 * @param id - Territory ID to fetch (skips for 'addNew', 'USE_MAP_NO_TERRITORY', or falsy values)
 * @returns Query result with territory data
 */
const useGetMedTerritory = (id: string | number | null) => {
  const stringId = id != null ? String(id) : '';
  const shouldFetch =
    Boolean(id) && stringId !== 'addNew' && stringId !== 'USE_MAP_NO_TERRITORY';

  const result = useGetTerritoryQuery(
    { territoryId: stringId },
    { skip: !shouldFetch }
  );

  return {
    data: result.data,
    error: result.error,
    isLoading: result.isLoading,
    isValidating: result.isFetching,
    mutate: result.refetch,
  };
};

export default useGetMedTerritory;
